import PlatfromConfigState from '../interfaces/state';

const platfromConfigInitialState: PlatfromConfigState = {
  cityConfigs: null,
  servicePrices: null,
};

export default platfromConfigInitialState;
